import React from 'react';

interface GiftIconProps {
  className?: string;
}

function GiftIcon({ className }: GiftIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className={className}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 12v10H4V12m18-5H2v5h20V7zM12 22V7m0 0H7.5a2.5 2.5 0 110-5C11 2 12 7 12 7zm0 0h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"
      ></path>
    </svg>
  );
}

export default GiftIcon;
